import { SVGProps } from 'react';

const Rainbow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M22 17a10 10 0 0 0-20 0m4 0a6 6 0 1 1 12 0m-8 0a2 2 0 0 1 4 0"
    />
  </svg>
);
export default Rainbow;
